<!-- 树形搜索 -->
<template>
  <div>
    <el-popover
      ref="popover"
      placement="bottom-start"
      trigger="click"
      v-model="popoverVisible"
      :disabled="targetItem.isDisabled"
      @show="onShowPopover"
      @hide="onHidePopover"
    >
      <el-tree
        ref="tree"
        class="select-tree"
        highlight-current
        default-expand-all
        node-key="id"
        :expand-on-click-node="isExpand"
        :style="`min-width: ${treeWidth}`"
        :data="treeData"
        :current-node-key="form[targetItem.name]"
        :props="defaultProps"
        :filter-node-method="handleFilterNode"
        @current-change="handleNodeClick"
      ></el-tree>
      <el-input
        slot="reference"
        ref="input"
        v-model="form[targetItem.nameLabel]"
        clearable
        :disabled="targetItem.isDisabled"
        :style="`width: ${width}px`"
        :class="{ 'rotate': popoverVisible }"
        suffix-icon="el-icon-arrow-down"
        :placeholder="'请选择' + targetItem.label"
        @change="handleClear"
      >
      </el-input>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'SelectTree',
  data() {
    return {
      isExpand: false,
      // 树状菜单显示状态
      popoverVisible: false,
      treeWidth: 'auto'
    }
  },

  props: {
    // 输入框宽度
    width: String,
    form: {
      type: Object,
      default: () => { }
    },
    targetItem: {
      type: Object,
      default: () => { }
    },
    treeData: {
      type: Array,
      default: () => []
    },
    defaultProps: {
      type: Object,
      default: () => ({
        parent: 'parentId',
        value: 'id',
        label: 'menuName',
        children: 'childlist'
      })
    }
  },

  watch: {
    form(val) {
      if (this.form[this.targetItem.name]) {
        this.form[this.targetItem.nameLabel] = this.queryTree(this.treeData, this.form[this.targetItem.name])
        this.$nextTick().then(() => {
          this.$refs.tree.setCheckedKeys([this.form[this.targetItem.name]])
        })
      }
    }
  },

  created() {
    // 获取输入框宽度同步至树状菜单宽度
    this.$nextTick(() => {
      this.treeWidth = `${(this.width || this.$refs.input.$refs.input.clientWidth) - 24}px`
    })
  },

  mounted() {
    if (this.form[this.targetItem.name]) {
      // console.log(this.treeData)
      // console.log(this.form)
      this.form[this.targetItem.nameLabel] = this.queryTree(this.treeData, this.form[this.targetItem.name])
      this.$nextTick().then(() => {
        this.$refs.tree.setCheckedKeys([this.form[this.targetItem.name]])
      })
    }
  },

  methods: {
    // 显示时触发
    onShowPopover() {
      this.popoverVisible = true
      this.$refs.tree.filter(false)
    },
    // 隐藏时触发
    onHidePopover() {
      this.popoverVisible = false
    },
    // 树节点过滤方法
    handleFilterNode(query, data) {
      if (!query) return true
      return data[this.defaultProps.label].indexOf(query) !== -1
    },
    handleNodeClick(val) {
      this.$emit('selected', { val: val, targetItem: this.targetItem, formName: this.targetItem.formName })
      this.onHidePopover()
    },
    handleClear(val) {
      this.$emit('selected', { val: val, targetItem: this.targetItem, formName: this.targetItem.formName })
      window.event.stopPropagation()
    },
    // 搜索树状数据中的 ID
    queryTree(tree, id) {
      let stark = []
      stark = stark.concat(tree)
      while (stark.length) {
        const temp = stark.shift()
        if (temp[this.defaultProps.children]) {
          stark = stark.concat(temp[this.defaultProps.children])
        }
        if (temp[this.defaultProps.value] === id) {
          return temp[this.defaultProps.label]
        }
      }
      return
    }
  }
}

</script>
<style>
.el-input.el-input--suffix.rotate .el-input__suffix .el-icon-arrow-down {
  transform: rotate(-180deg);
}
.select-tree {
  max-height: 400px;
  overflow-y: scroll;
}
</style>